import styled from '@emotion/styled';

const InputWrapper = styled.div({
  margin: '10px 0'
});

export default InputWrapper;
